import ProjPresentPictureItem from './proj-present-image-item'
export default ProjPresentPictureItem;
